import { render, staticRenderFns } from "./TemplateIndex.vue?vue&type=template&id=365c8331&"
import script from "./TemplateIndex.vue?vue&type=script&lang=ts&"
export * from "./TemplateIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports